<template>
  <article class="wx-article" :lang="isEnglish ? 'en' : 'zh-CN'">
    <div class="wx-inner">
      <h1 class="wx-title">{{ article.title }}</h1>
      <template v-for="(block, index) in article.blocks" :key="index">
        <div
          v-if="block.type === 'image'"
          class="wx-media is-center"
          :style="{ marginBottom: block.mb + 'px' }"
        >
          <img
            :src="isEnglish && block.srcEn ? block.srcEn : block.src"
            :alt="article.title"
            class="is-full"
            loading="lazy"
          />
        </div>
        <div v-else-if="block.type === 'headline'" class="wx-headline" :style="blockStyle(block)">
          {{ block.text }}
        </div>
        <p v-else-if="block.type === 'p'" class="wx-p" :style="blockStyle(block)">
          <span v-for="(seg, si) in block.segs" :key="si" :class="seg.c">{{ seg.t }}</span>
        </p>
      </template>
    </div>
  </article>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { locale } = useI18n();
const isEnglish = computed(() => locale.value === "en");

const IMG = "https://www.healthcode.com/media/20261102";
const IMG_EN = "https://www.healthcode.com/media/20261102/en";

const img = (name, nameEn) => ({
  type: "image",
  src: `${IMG}/${name}`,
  srcEn: `${IMG_EN}/${nameEn || name}`,
  mb: 24,
});

const headline = (text) => ({ type: "headline", text, mt: 32, mb: 32 });

const p = (...segs) => ({
  type: "p",
  segs: segs.map((s) => (typeof s === "string" ? { t: s, c: "" } : s)),
  mt: 24,
  mb: 24,
});

const content = {
  zh: {
    title: "康码Bio-Reactor S200 无细胞合成桌面反应器，6-24独立通道，D2P技术赋能AI蛋白高质量合成！",
    blocks: [
      img("P1.png"),
      img("P2.png"),
      p(
        "康码基于全球领先D2P真核无细胞蛋白质合成技术，赋能AI制造未来发展，开发出了全球首台升级体量的",
        { t: "无细胞合成桌面反应器", c: "b" },
        "，Bio-Reactor S200。"
      ),
      headline("Bio-Reactor S200，拥有6-24独立通道，结合ProteinFactory Liter 蛋白质工厂升级合成套装"),
      img("P3-1.png"),
      img("P3-2.png"),
      p(
        "Bio-Reactor S200，拥有6-24独立通道，结合ProteinFactory Liter 蛋白质工厂升级合成套装，可同时、独立、合成6-24种不同类型的目标蛋白，每批次产量最多可达 2.4 g（依蛋白质序列不同），充分满足实验室级g级蛋白质合成需求，0.5-3 小时一批，独有量产级真核合成体系ProteinFactory，更加适配复杂的蛋白质分子——简便、快速、高效、高质量、高一致性，是您实验放大、产量提升、中试摸索的必选产品。"
      ),
      headline("「六釜多通道，灵活适配蛋白表达」"),
      img("P4-1.png"),
      img("P4-2.png"),
      p(
        "Bio-Reactor S200，拥有6个独立反应釜，每个反应釜可支持1-4个独立通道反应杯，每个单通道支持无细胞蛋白合成反应体积10-200 mL，可覆盖实验室日常不同类型，不同数量，不同产量要求的，各种蛋白表达需求。"
      ),
      headline("「真核体系赋能AI蛋白创新」"),
      img("P5-1.png"),
      p(
        "Bio-Reactor S200，设计适配康码ProteinFactory Liter 蛋白质工厂升级合成套装，全球首个支持1000 mL级体积以上的无细胞蛋白质合成产品，真核体系，支持各种复杂序列，含二硫键蛋白等，尤其适合AI设计的，自然界不存在的全新蛋白质分子，超高折叠效率，高保真、高得率，高性价比！"
      ),
      headline("「从分子灵感到未来制造」"),
      img("P6-1.png"),
      p("Bio-Reactor S200，用创新科技，开辟AI蛋白质设计、研究、到规模化制造的21世纪全新时代！"),
      headline("「一键启动，智控全程」"),
      img("P7-1.png"),
      p(
        "康码Bio-Reactor S200，全自动AI智能控制，一键启动，数字化全程监控，自动记录多重合成环境参数，远程控制，100%中国制造的高端设备！"
      ),
      headline("「让科研更高效、更简单、更稳定」"),
      img("P8-1.png"),
      p("康码Bio-Reactor S200，专为科学家和工程师设计，满足各种科研需求，更高效率，更简便，更稳定！"),
      headline("「让科研成果，更快抵达」"),
      img("P9-1.png"),
      p(
        "康码 Bio-Reactor S200，提高您的实验效率，提高蛋白质样本制备质量，提升纯度，缩短时间，增加数据一致性，加速实现更高科研成果！"
      ),
      headline("「让每个通道，都成为探索的起点」"),
      img("P10-1.png"),
      p(
        "Bio-Reactor S200专配 无细胞合成高效反应杯CFCup，拥有6-24独立通道，结合全新 D2P 专利技术，轻松满足实验室级无细胞蛋白质合成需求。"
      ),
      headline("「让高质量目标蛋白，快速抵达」"),
      img("P11-1.png"),
      p(
        "搭配真核无细胞蛋白质合成 ProteinFactory Fast Liter 产品使用，快速蛋白质合成，更高得率，更有活性，高质量目标蛋白，轻松合成！"
      ),
      img("P12.png"),
      img("P13.png"),
      { type: "p", segs: [{ t: "THANK YOU", c: "thanks" }], mt: 24, mb: 8 },
    ],
  },
  en: {
    title:
      "Healthcode Bio-Reactor S200 Cell-Free Synthesis Desktop Reactor — 6–24 Independent Channels, D2P Technology Empowers High-Quality AI Protein Synthesis",
    blocks: [
      img("P1.png"),
      img("P2.png"),
      p(
        "Based on its globally leading D2P eukaryotic cell-free protein synthesis technology, Healthcode empowers the future of AI-driven manufacturing and has developed Bio-Reactor S200, the world's first upgraded-volume ",
        { t: "desktop cell-free synthesis reactor", c: "b" },
        "."
      ),
      headline("Bio-Reactor S200: 6–24 independent channels, combined with the ProteinFactory Liter upgraded protein factory synthesis kit"),
      img("P3-1.png"),
      img("P3-2.png"),
      p(
        "Bio-Reactor S200 features 6–24 independent channels. Combined with the ProteinFactory Liter protein factory upgraded synthesis kit, it can synthesize 6–24 different target proteins simultaneously and independently, with a maximum yield of up to 2.4 g per batch (depending on the protein sequence), fully meeting laboratory-grade, gram-level protein synthesis needs. Each batch takes 0.5–3 hours. With its unique production-grade eukaryotic synthesis system ProteinFactory, it is even better suited to complex protein molecules — simple, fast, efficient, high-quality and highly consistent. It is the must-have product for scale-up experiments, yield improvement and pilot-scale exploration."
      ),
      headline("Six reactors, multiple channels — flexible for protein expression"),
      img("P4-1.png"),
      img("P4-2.png"),
      p(
        "Bio-Reactor S200 has 6 independent reactors, each supporting 1–4 independent channel reaction cups. Each single channel supports a cell-free protein synthesis reaction volume of 10–200 mL, covering the everyday laboratory needs of different protein expression types, quantities and yield requirements."
      ),
      headline("Eukaryotic system empowers AI protein innovation"),
      img("P5-1.png"),
      p(
        "Bio-Reactor S200 is designed to work with Healthcode's ProteinFactory Liter protein factory upgraded synthesis kit — the world's first cell-free protein synthesis product supporting volumes of 1000 mL and above. With its eukaryotic system, it supports all kinds of complex sequences, including proteins containing disulfide bonds, and is especially suited to entirely new protein molecules designed by AI that do not exist in nature — with ultra-high folding efficiency, high fidelity, high yield and high cost-effectiveness!"
      ),
      headline("From molecular inspiration to future manufacturing"),
      img("P6-1.png"),
      p(
        "With innovative technology, Bio-Reactor S200 opens up a new 21st-century era — from AI protein design and research to scale-up manufacturing!"
      ),
      headline("One-touch start, full-process intelligent control"),
      img("P7-1.png"),
      p(
        "Healthcode Bio-Reactor S200: fully automatic AI intelligent control, one-touch start, digital whole-process monitoring, automatic recording of multiple synthesis environment parameters, remote control — high-end equipment made 100% in China!"
      ),
      headline("Making research more efficient, simpler and more stable"),
      img("P8-1.png"),
      p(
        "Healthcode Bio-Reactor S200 is designed for scientists and engineers, meeting every research need — more efficient, simpler and more stable!"
      ),
      headline("Bringing research results faster"),
      img("P9-1.png"),
      p(
        "Healthcode Bio-Reactor S200 raises your experimental efficiency, improves the quality of protein sample preparation, increases purity, shortens time, boosts data consistency and accelerates higher research achievements!"
      ),
      headline("Every channel — a new starting point for discovery"),
      img("P10-1.png"),
      p(
        "Bio-Reactor S200 is specially equipped with the CFCup high-efficiency cell-free synthesis reaction cup: 6–24 independent channels combined with the all-new patented D2P technology easily meet laboratory-grade cell-free protein synthesis needs."
      ),
      headline("High-quality target proteins, delivered fast"),
      img("P11-1.png"),
      p(
        "Paired with the eukaryotic cell-free protein synthesis product ProteinFactory Fast Liter, it enables rapid protein synthesis with higher yield, greater activity and high-quality target proteins — synthesis made easy!"
      ),
      img("P12.png"),
      img("P13.png"),
      { type: "p", segs: [{ t: "THANK YOU", c: "thanks" }], mt: 24, mb: 8 },
    ],
  },
};

const blockStyle = (block) => ({
  marginTop: block.mt !== undefined ? block.mt + "px" : null,
  marginBottom: block.mb !== undefined ? block.mb + "px" : null,
});

const article = computed(() => (isEnglish.value ? content.en : content.zh));
</script>

<style scoped>
.wx-article {
  width: 100%;
  min-height: 100vh;
  padding: 8rem 0 4rem;
  background: #fff;
}

.wx-inner {
  max-width: 677px;
  margin: 0 auto;
  padding: 0 16px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
  font-size: 17px;
  line-height: 1.75;
  letter-spacing: 0.034em;
  color: #333;
  text-align: justify;
  overflow-wrap: break-word;
}

.wx-title {
  margin: 0 0 24px;
  color: #222;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.4;
  text-align: left;
}

.wx-p {
  margin: 0 0 16px;
}

/* 小标题：居中加粗 + 下方红色细分隔线 */
.wx-headline {
  padding-bottom: 12px;
  border-bottom: 1px solid #955355;
  color: #000;
  font-size: 26px;
  font-weight: 700;
  line-height: 1.6;
  letter-spacing: 0.02em;
  text-align: center;
}

.wx-media {
  margin: 0 0 16px;
  text-align: center;
}

.wx-media img {
  display: inline-block;
  width: 100%;
  max-width: 100%;
  height: auto;
  vertical-align: middle;
}

.b {
  font-weight: bold;
}

.thanks {
  display: block;
  color: #555;
  font-size: 24px;
  letter-spacing: 0.2em;
  text-align: center;
}

@media (max-width: 640px) {
  .wx-article {
    padding-top: 7rem;
  }

  .wx-inner {
    font-size: 16px;
  }

  .wx-title {
    font-size: 19px;
  }

  .wx-headline {
    font-size: 21px;
  }

  .thanks {
    font-size: 19px;
  }
}
</style>
